import './instrument';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './utils/isA2uiV08BotReplyPayload';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ready as appStorageReady } from './utils/appIndexedDB';
import { ensureDeviceId } from './utils/deviceId';
import { AppConfigProvider } from './context/AppConfigContext';
import { applyThemeToDocument, getStoredTheme } from './hooks/useTheme';
import { initOfficialSiteBridge } from './utils/officialSiteBridge';
import { installMaintenanceKeyInjector } from './utils/maintenance';

/* 維護模式放行金鑰：已儲存時，所有對 /bff 的 fetch 自動附上 X-Maint-Key（需在任何 API 呼叫前安裝） */
installMaintenanceKeyInjector();

/* 首幀前同步 localStorage 主題，避免 useTheme 首次 effect 前缺 data-theme 與令牌不一致 */
applyThemeToDocument(getStoredTheme());

/* 必須在 React 掛載前呼叫，確保 message 監聽先掛好才送出 READY 訊號給開出本頁的官網視窗 */
initOfficialSiteBridge();

const root = ReactDOM.createRoot(document.getElementById('root'));

appStorageReady()
  .then(() => ensureDeviceId())
  .catch(() => {})
  .finally(() => {
    root.render(
      <React.StrictMode>
        <AppConfigProvider>
          <App />
        </AppConfigProvider>
      </React.StrictMode>
    );
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
